const CoordinatesNavigation = {
  order: Infinity,
  run($$) {
    const vericalNavStyle = {
      top: `${$$.SEAT_HEIGHT}px`,
      width: `${$$.SEAT_WIDTH}px`,
    };

    const $seatsHorizontalNav = $("<div class='seats-horizontal-nav' />").appendTo($$.$arena);
    const $seatsHorizontalBottomNav = $("<div class='seats-horizontal-nav seats-horizontal-bottom-nav' />").appendTo($$.$arena);
    const $seatsVerticalNav = $("<div class='seats-vertical-nav' />")
      .appendTo($$.$arena)
      .css(vericalNavStyle);
    const $seatsVerticalRightNav = $("<div class='seats-vertical-nav seats-vertical-right-nav' />")
      .appendTo($$.$arena)
      .css(vericalNavStyle);

    $seatsHorizontalNav.append($("<div class='rulers-number' />"))
      .css({
        width: 1,
        height: $$.SEAT_HEIGHT,
        backgroundColor: "#777",
      })
      .hide();
    $seatsHorizontalBottomNav.append($("<div class='rulers-number' />"))
      .css({
        width: 1,
        height: $$.SEAT_HEIGHT,
        backgroundColor: "#777",
      })
      .css({
        marginTop: 10,
      })
      .hide();
    $seatsVerticalNav.append($("<div class='rulers-number' />").hide());
    $seatsVerticalRightNav.append($("<div class='rulers-number' />"))
      .css({
        marginLeft: 10,
      })
      .hide();
    const $horizontalRuler = $$.$arena.find(".seats-horizontal-nav .rulers-number");
    const $verticalRuler = $$.$arena.find(".seats-vertical-nav .rulers-number");

    const leaveHandler = () => {
      $horizontalRuler.hide();
      $verticalRuler.hide();
    };

    const moveHandler = (event) => {
      const x = event.clientX - $(event.currentTarget).offset().left;
      const y = event.clientY - $(event.currentTarget).offset().top;
      $horizontalRuler.show();
      $verticalRuler.show();

      $horizontalRuler.css({
        left: ((x - 0.5) / ($$.baseScale || 1)),
      });
      $verticalRuler.css({
        top: ((y - 0.5) / ($$.baseScale || 1)),
      });
    };


    $$.$arena.on("mouseleave", ".seats-container", leaveHandler);
    $$.$arena.on("mousemove", ".seats-container", moveHandler);
  },

};

window.SectionCoordinatesNavigation = CoordinatesNavigation;

export default CoordinatesNavigation;
